<template>
  <v-form ref="form" v-model="valid">
    <v-row>
      <v-col class="pb-0">
        <v-text-field
          v-if="requireOldPass"
          id="reset-pwd-form-old-password-input"
          counter
          dense
          required
          outlined
          label="Old Password"
          v-model="model.current_password"
          :rules="rules.current_password"
          :error-count="rules.current_password.length"
          :append-icon="hide.current ? 'mdi-eye-off' : 'mdi-eye'"
          :type="hide.current ? 'password' : 'text'"
          :disabled="loading"
          @click:append="hide.current = !hide.current"
          v-on:keyup.enter="emitSubmit"
        />
        <v-form ref="pwdsForm">
          <v-text-field
            id="reset-pwd-form-password-input"
            counter
            dense
            required
            outlined
            label="New Password"
            ref="newPasswordField"
            v-model="model.new_password"
            :rules="rules.new_password"
            :error-count="rules.new_password.length"
            :append-icon="hide.new ? 'mdi-eye-off' : 'mdi-eye'"
            :type="hide.new ? 'password' : 'text'"
            :disabled="loading"
            @click:append="hide.new = !hide.new"
            v-on:keyup.enter="emitSubmit"
          />
          <v-text-field
            id="reset-pwd-form-confirm-password-input"
            counter
            dense
            required
            outlined
            label="Confirm New Password"
            v-model="model.confirm_new_password"
            :rules="rules.confirm_new_password.concat(v => (v === model.new_password || 'Passwords do not match'))"
            :error-count="rules.confirm_new_password.length + 1"
            :append-icon="hide.confirm ? 'mdi-eye-off' : 'mdi-eye'"
            :type="hide.confirm ? 'password' : 'text'"
            :disabled="loading"
            @click:append="hide.confirm = !hide.confirm"
            v-on:keyup.enter="emitSubmit"
          />
        </v-form>
      </v-col>
    </v-row>
    <div v-if="tip" class="text-right mb-3">
      {{ tip }}
    </div>
  </v-form>
</template>

<script>
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
import PASS_MODEL from './resources/model';
import FORM_RULES from './resources/rules';


export default {
  name: 'ResetPasswordForm',
  props: {
    requireOldPass: Boolean,
    tip: String,
    loading: Boolean,
  },
  data: vm => ({
    model: vm.$utils.deepCopy(PASS_MODEL),
    hide: {
      current: true,
      new: true,
      confirm: true,
    },
    rules: FORM_RULES,
    valid: false,
  }),
  computed: {
    submitDisabled() {
      return !this.valid || this.loading;
    },
    pwdValue: vm => vm.model.password,
    confirmPwdValue: vm => vm.model.confirm_password,
  },
  methods: {
    validate() {
      const formValid = this.$refs.form.validate();
      const pwdFormValid = this.$refs.pwdsForm.validate();
      return formValid && pwdFormValid;
    },
    getModel() {
      return this.$utils.deepCopy(this.model);
    },
    reset() {
      this.$refs.form.reset();
      this.model = this.$utils.deepCopy(PASS_MODEL);
    },
    emitSubmit() {
      if (this.validate()) {
        this.$emit('submit', this.model);
      }
    },
  },
  watch: {
    pwdValue() {
      this.$refs.pwdsForm.validate();
    },
    confirmPwdValue() {
      this.$refs.pwdsForm.validate();
    },
  },
};
</script>
